import { html, type TemplateResult } from 'lit';

export interface AppButtonProps {
  variant?: 'primary' | 'secondary' | 'text';
  size?: 'sm' | 'md' | 'lg';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  label?: string;
  onClick?: (e: MouseEvent) => void;
}

export function renderAppButtonPresentation(props: AppButtonProps): TemplateResult {
  const {
    variant = 'primary',
    size = 'md',
    type = 'button',
    disabled = false,
    label,
    onClick,
  } = props;

  const btnClasses = [
    'app-btn',
    `variant-${variant}`,
    `size-${size}`,
    disabled ? 'btn-disabled' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return html`
    <button
      type=${type}
      class=${btnClasses}
      ?disabled=${disabled}
      @click=${(e: MouseEvent) => !disabled && onClick?.(e)}
    >
      <slot name="icon-left"></slot>
      ${label ? html`<span>${label}</span>` : html`<slot></slot>`}
      <slot name="icon-right"></slot>
    </button>
  `;
}
